import { motion } from "framer-motion";
import { Star, Check, ArrowUpRight } from "lucide-react";

export default function AffiliateGearCard({ item, index = 0 }) {
    const href = item.vendorType === "amazon" ? `${item.link}&tag=troutstart-20` : item.link;
    return (
        <motion.article
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group rounded-2xl border border-white/10 bg-[#111C2E] overflow-hidden hover:border-teal/40 transition-colors duration-500 flex flex-col"
            data-testid={`gear-card-${item.id}`}
        >
            <div className="relative overflow-hidden aspect-[4/3]">
                <img
                    src={item.image}
                    alt={item.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111C2E] via-transparent to-transparent" />
                <span
                    className={`absolute top-4 left-4 rounded-full px-3 py-1 font-mono text-[10px] tracking-[0.18em] uppercase backdrop-blur-md ${
                        item.vendorType === "amazon"
                            ? "bg-gold/15 text-gold border border-gold/30"
                            : "bg-teal/15 text-teal border border-teal/30"
                    }`}
                >
                    {item.vendor}
                </span>
                <span className="absolute bottom-3 right-4 font-serif text-2xl font-bold text-slate-50 drop-shadow-lg">
                    {item.price}
                </span>
            </div>

            <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-2">
                    <div className="flex gap-0.5">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <Star
                                key={i}
                                size={13}
                                className={i < Math.round(item.rating) ? "fill-gold text-gold" : "text-slate-600"}
                            />
                        ))}
                    </div>
                    <span className="font-mono text-xs text-slate-400">
                        {item.rating} · {item.reviews.toLocaleString()} reviews
                    </span>
                </div>

                <h3 className="mt-3 font-sans text-lg font-medium text-slate-100 leading-snug">{item.name}</h3>

                <div className="mt-3 flex flex-wrap gap-1.5">
                    {item.specs.map((s) => (
                        <span key={s} className="rounded-md bg-white/5 px-2 py-1 font-mono text-[10px] tracking-wide text-slate-400">
                            {s}
                        </span>
                    ))}
                </div>

                <ul className="mt-4 space-y-1.5 flex-1">
                    {item.pros.map((p) => (
                        <li key={p} className="flex items-start gap-2 font-body text-sm text-slate-400">
                            <Check size={14} className="mt-0.5 shrink-0 text-teal" />
                            {p}
                        </li>
                    ))}
                </ul>

                <a
                    href={href}
                    target="_blank"
                    rel="sponsored noopener noreferrer"
                    data-testid={`affiliate-buy-button-${item.id}`}
                    className="mt-6 flex items-center justify-center gap-2 rounded-xl border border-teal/40 bg-teal/10 px-4 py-3 font-sans text-sm font-semibold text-teal transition-colors duration-300 hover:bg-teal hover:text-[#0B1320]"
                >
                    Check Price <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
            </div>
        </motion.article>
    );
}
